import { isAuthenticated } from '../../utils/auth';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from './Hero';
import Stats from './Stats';
import ContinueLearning from './ContinueLearning';
import FeaturedCourses from './FeaturedCourses';
import BrowseByDepartment from './BrowseByDepartment';
import WhyAcademy from './WhyAcademy';
import ReadyToStart from './ReadyToStart';
import './Hero.css';
import './Stats.css';
import './ContinueLearning.css';
import './FeaturedCourses.css';
import './BrowseByDepartment.css';
import './WhyAcademy.css';
import './ReadyToStart.css';

const Home = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();



  const browseByDepartmentRef = React.useRef(null);
  const featuredCoursesRef = React.useRef(null);

  const handleStartLearningClick = () => {
    browseByDepartmentRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const handlePopularCoursesClick = () => {
    if (featuredCoursesRef.current) {
      featuredCoursesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const name = urlParams.get('name');
    const department = urlParams.get('department');
    const email = urlParams.get('email');
    const jobTitle = urlParams.get('jobTitle');
    const token = urlParams.get('token');

    console.log('Home useEffect ran. Query Params:', { name, department, email,jobTitle, token });

    if (name && email && token && jobTitle) {
      if (!isAuthenticated()) {
        return null;
      }
      return (
        <div>
          <Hero onStartLearningClick={handleStartLearningClick} />
          <Stats onPopularCoursesClick={handlePopularCoursesClick} />
          <ContinueLearning />
          <div ref={featuredCoursesRef}>
            <FeaturedCourses />
          </div>
          <div ref={browseByDepartmentRef}>
            <BrowseByDepartment />
          </div>
          {/* <PopularCertifications /> */}
          <WhyAcademy />
          <ReadyToStart />
        </div>
      );
    }
  }, [navigate, window.location.search]);

  return (
    <>
      <Hero onStartLearningClick={handleStartLearningClick} />
      <Stats onPopularCoursesClick={handlePopularCoursesClick} />
      <ContinueLearning />
      <div ref={featuredCoursesRef}>
        <FeaturedCourses />
      </div>
      <div ref={browseByDepartmentRef}>
         <BrowseByDepartment />
      </div>
      {/* <PopularCertifications /> */}
      <WhyAcademy />
      <ReadyToStart />
    </>
  );
};

export default Home;